import { api } from "@/api/axios";

import type {
  AcceptInvitationRequest,
  AcceptInvitationResponse,
  InvitationValidationResponse,
} from "../types/onboarding";


export async function validateInvitation(
  token: string,
): Promise<InvitationValidationResponse> {
  const response = await api.get(
    "/api/invitations/" + token,
  );

  return response.data;
}


export async function acceptInvitation(
  token: string,
  data: AcceptInvitationRequest,
): Promise<AcceptInvitationResponse> {
  const response = await api.post(
    "/api/invitations/" + token + "/accept",
    data,
  );

  return response.data;
}
